import { z } from 'zod';

export const InputSchema = z.object({
    accountId: z.number(),
});

export type ReferralValidationSchemaType = z.infer<typeof InputSchema>;

export const SuccessResponseSchema = z.string();

export type SuccessResponseType = z.infer<typeof SuccessResponseSchema>;

export const ErrorLockedResponseSchema = z.object({
    errors: z.array(
        z.object({
            field: z.string(),
            message: z.string(),
        })
    ),
});
export type ErrorLockedResponseType = z.infer<typeof ErrorLockedResponseSchema>;

export type ResponseType =
    | { responseStatus: 'success'; data: SuccessResponseType }
    | {
          responseStatus: 'error';
          data: ErrorLockedResponseType;
          unparsedData?: unknown;
      };
